
export default function Destinations() {
  return (
    <section id="destinations" className="py-16 sm:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <h3 className="text-3xl sm:text-4xl lg:text-5xl font-bold">
            <span className="text-slate-900">Popular </span>
            <span className="text-emerald-500">Study Destinations</span>
          </h3>
        </div>

        <div className="grid lg:grid-cols-2 gap-4 sm:gap-6">
          <div className="relative h-[300px] sm:h-[400px] lg:h-[600px] rounded-3xl overflow-hidden group cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/125c0973c1ee8db26f67b2a01e91156a.jpg"
              alt="United Kingdom"
              className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/40 to-transparent"></div>
            <div className="absolute bottom-6 sm:bottom-8 left-6 sm:left-8 text-white">
              <h4 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-2">United Kingdom</h4>
              <p className="text-emerald-400 text-sm sm:text-base font-medium">150+ Partner Universities</p>
              <p className="text-gray-300 text-xs sm:text-sm mt-2 sm:mt-3 max-w-md">
                World-renowned institutions, rich cultural heritage, and excellent post-study work opportunities.
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-4 sm:gap-6">
            <div className="relative h-[200px] sm:h-[250px] lg:h-[292px] rounded-3xl overflow-hidden bg-gradient-to-br from-emerald-400 to-emerald-600 group cursor-pointer">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-24 sm:w-32 h-24 sm:h-32 flex items-center justify-center">
                  <i className="ri-maple-leaf-line text-7xl sm:text-9xl text-white/30"></i>
                </div>
              </div>
              <div className="relative z-10 p-6 sm:p-8 h-full flex flex-col justify-end">
                <h4 className="text-2xl sm:text-3xl font-bold text-white mb-1 sm:mb-2">Canada</h4>
                <p className="text-white/90 text-sm sm:text-base font-medium">Pathway Programs Available</p>
                <p className="text-white/80 text-xs sm:text-sm mt-2 sm:mt-3">
                  Welcoming immigration policies, affordable education, and multicultural cities perfect for international students.
                </p>
              </div>
            </div>

            <div className="relative h-[200px] sm:h-[250px] lg:h-[292px] rounded-3xl overflow-hidden bg-gradient-to-br from-orange-400 to-red-500 group cursor-pointer">
              <div className="absolute inset-0 flex items-center justify-center opacity-20">
                <div className="w-24 sm:w-32 h-24 sm:h-32 flex items-center justify-center">
                  <i className="ri-sun-line text-7xl sm:text-9xl text-white"></i>
                </div>
              </div>
              <div className="relative z-10 p-6 sm:p-8 h-full flex flex-col justify-end">
                <h4 className="text-2xl sm:text-3xl font-bold text-white mb-1 sm:mb-2">Australia</h4>
                <p className="text-white/90 text-sm sm:text-base font-medium">Post-Study Work Opportunities</p>
                <p className="text-white/80 text-xs sm:text-sm mt-2 sm:mt-3">
                  High quality of life, innovative teaching methods, and excellent career prospects in a vibrant environment.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 sm:mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          <div className="relative h-40 sm:h-48 rounded-3xl overflow-hidden bg-gradient-to-br from-blue-500 to-blue-700 group cursor-pointer">
            <div className="relative z-10 p-6 h-full flex flex-col justify-end">
              <h4 className="text-xl sm:text-2xl font-bold text-white mb-1">United States</h4>
              <p className="text-white/90 text-xs sm:text-sm font-medium">Top-Ranked Universities</p>
            </div>
          </div>

          <div className="relative h-40 sm:h-48 rounded-3xl overflow-hidden bg-gradient-to-br from-red-500 to-pink-600 group cursor-pointer">
            <div className="relative z-10 p-6 h-full flex flex-col justify-end">
              <h4 className="text-xl sm:text-2xl font-bold text-white mb-1">New Zealand</h4>
              <p className="text-white/90 text-xs sm:text-sm font-medium">Safe &amp; Scenic Environment</p>
            </div>
          </div>

          <div className="relative h-40 sm:h-48 rounded-3xl overflow-hidden bg-gradient-to-br from-purple-500 to-indigo-600 group cursor-pointer">
            <div className="relative z-10 p-6 h-full flex flex-col justify-end">
              <h4 className="text-xl sm:text-2xl font-bold text-white mb-1">Ireland</h4>
              <p className="text-white/90 text-xs sm:text-sm font-medium">Tech Hub of Europe</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
